<ng-container *ngIf="isOffline(album._id); else default">
    <ion-icon name="cloud-done" style="color: #42C8B5" (click)="showToaster('\<b>We got it!\</b> This download is in your library.')"></ion-icon>
</ng-container>

<ng-template #default>
    <ion-icon name="cloud-download-outline" (click)="downloadAlbum(album)"></ion-icon>
</ng-template>